import { Dialog } from '@mui/material';
import React from 'react';
import AddForm from './AddForm';
import EditForm from './EditForm';

const SegmentToggleModal = ({
  open,
  toggle,
  isEdit,
  getData,
  data,
  length,
  setSnackBarOpenS,
  setSnackbarSeverityS,
  setSnackBarMessageS,
  getSegmentData
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      {!isEdit && (
        <AddForm
          open={open}
          toggle={toggle}
          getData={getData}
          getSegmentData={getSegmentData}
          length={length}
          setSnackBarOpenS={setSnackBarOpenS}
          setSnackbarSeverityS={setSnackbarSeverityS}
          setSnackBarMessageS={setSnackBarMessageS}
        />
      )}
      {isEdit && (
        <EditForm 
        open={open} 
        toggle={toggle} 
        data={data} 
        getData={getData} 
        setSnackBarOpenS={setSnackBarOpenS}
        setSnackbarSeverityS={setSnackbarSeverityS}
        setSnackBarMessageS={setSnackBarMessageS} />
      )}
    </Dialog>
  );
};

export default SegmentToggleModal;
